<template>
  <div id="all-events-list">
    <!-- Global overlay for longer operations -->
    <v-overlay :value="ProgressLoadingFlag" absolute>
      <v-card class="overlay-card pa-6 text-center">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        ></v-progress-circular>
        <div class="mt-3 font-weight-medium">Loading, please wait...</div>
      </v-card>
    </v-overlay>

    <v-card class="report-card elevation-6">
      <v-sheet
        color="white"
        class="header-sheet pa-6 d-flex align-center justify-space-between"
      >
        <div>
          <h1 class="report-title">{{ PageTitle }}</h1>
          <div class="report-subtitle">
            {{ PageDescription }}
          </div>
        </div>
        <v-avatar size="64" class="report-avatar elevation-2">
          <v-icon size="36" color="#fff">mdi-sitemap</v-icon>
        </v-avatar>
      </v-sheet>

      <v-footer :fixed="true" :absolute="false" :padless="true">
        <v-card
          flat
          tile
          width="100%"
          color="#8950FC"
          v-if="tableData1.length > 0"
        >
        </v-card>
      </v-footer>

      <v-card-text>
        <v-row wrap>
          <v-col align="start" cols="12" md="12">
            <div class="notes-content">
              <p><span class="text-danger">*</span> indicates required field</p>
            </div>
          </v-col>
        </v-row>

        <p></p>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container>
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="searchForm"
          >
            <v-row wrap>
              <v-col cols="12" sm="6" lg="4" md="4">
                <label>
                  <h6><span class="text-danger">*</span> Year</h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :items="JciYearCodeOptions"
                  :rules="JciYearCodeRules"
                  :loading="JciYearCodeOptionsLoading"
                  v-model="JciYearCode"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="4" md="4">
                <label>
                  <h6><span class="text-danger">*</span> Zone</h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  v-model="ZoneCode"
                  :rules="ZoneCodeRules"
                  :items="ZoneCodeOptions"
                  :loading="ZoneCodeOptionsLoading"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="getConferenceRecords"
                  :loading="SearchFlag"
                  color="primary"
                  elevation="8"
                  rounded
                  large
                  class="search-btn font-size-h6 px-8 py-3 my-3 mr-3 white--text"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>

        <transition name="fade-slide" mode="out-in">
          <v-container v-if="conference" key="conference">
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-card
                  class="conference-info-card pa-4 rounded-lg"
                  elevation="3"
                >
                  <div class="d-flex align-center mb-3">
                    <v-icon size="24" color="#2c63ac" class="mr-2"
                      >mdi-calendar-text</v-icon
                    >
                    <h2 class="text-h6 font-weight-bold mb-0">
                      Conference Details
                    </h2>
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="conference-details">
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">Zone:</div>
                      <div class="detail-value ml-2">
                        {{ conference.ZoneName }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Host LO:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.LomName }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Conference Date:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.ConferenceStartDate }} -
                        {{ conference.ConferenceEndDate }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Nomination Deadline:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.NominationEndDate }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center">
                      <div class="detail-label font-weight-medium">
                        Award Bidding:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.AwardStartDate }} -
                        {{ conference.AwardEndDate }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card
                  class="conference-info-card pa-4 rounded-lg"
                  elevation="3"
                >
                  <div class="d-flex align-center mb-3">
                    <v-icon size="24" color="#2c63ac" class="mr-2"
                      >mdi-account-tie</v-icon
                    >
                    <h2 class="text-h6 font-weight-bold mb-0">
                      Election Details
                    </h2>
                  </div>
                  <v-divider class="mb-3"></v-divider>
                  <div class="conference-details">
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Required ZP Count:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.ZonePresidentRequiredCount }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Required ZVP Count:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.ZvpCount }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Withdrawal Deadline:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.WithdrawalEndDate }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Withdrawal Extensions Count:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.WithdrawalExtendMaxCount }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center mb-2">
                      <div class="detail-label font-weight-medium">
                        Vacancy Count for ZP:
                      </div>
                      <div class="detail-value ml-2">
                        {{
                          conference.ZonePresidentRequiredCount -
                          conference.ZpNomineeCount
                        }}
                      </div>
                    </div>
                    <div class="detail-item d-flex align-center">
                      <div class="detail-label font-weight-medium">
                        Vacancy Count for ZVP:
                      </div>
                      <div class="detail-value ml-2">
                        {{ conference.ZvpCount - conference.ZvpNomineeCount }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </transition>
        <!-- Nomination Lists -->
        <transition-group name="card-fade" tag="div">
          <v-row v-if="ResultFlag" key="result-1">
            <v-col cols="12" md="6">
              <nomination-list
                :key="`nomination-zp-${componentsRefreshKey}`"
                :year="JciYearCode"
                :zone="ZoneCode"
                title="Zone President Nominees"
                :designation="3"
                :type="1"
                :enableApplication="true"
                :enableScore="true"
                :enableAgeProof="true"
              />
            </v-col>
            <v-col cols="12" md="6">
              <nomination-list
                :key="`nomination-zvp-${componentsRefreshKey}`"
                :year="JciYearCode"
                :zone="ZoneCode"
                title="Zone Vice President Nominees"
                :designation="4"
                :type="2"
                :enableApplication="true"
                :enableScore="true"
                :enableAgeProof="true"
              />
            </v-col>
          </v-row>
        </transition-group>

        <!-- DisQualification Lists -->
        <v-row v-if="ResultFlag">
          <v-col cols="12" md="6">
            <disqualified-list
              :key="`disq-zp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Disqualified ZP Candidates "
              :designation="3"
              :type="3"
              :enableDisqualify="true"
            />
          </v-col>
          <v-col cols="12" md="6">
            <disqualified-list
              :key="`disq-zvp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Disqualified ZVP Candidates "
              :designation="4"
              :type="4"
              :enableDisqualify="true"
            />
          </v-col>
        </v-row>

        <!-- Withdrawal Lists -->
        <v-row v-if="ResultFlag">
          <v-col cols="12" md="6">
            <withdrawal-list
              :key="`withdrawal-zp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Withdrawal ZP Candidates "
              :designation="3"
              :type="5"
            />
          </v-col>
          <v-col cols="12" md="6">
            <withdrawal-list
              :key="`withdrawal-zvp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Withdrawal ZVP Candidates "
              :designation="4"
              :type="6"
            />
          </v-col>
        </v-row>

        <!-- Contested and Loss Lists -->
        <v-row v-if="ResultFlag">
          <v-col cols="12" md="6">
            <contested-loss-list
              :key="`contested-zp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Contested & Lost ZP Candidates "
              :designation="3"
              :type="7"
            />
          </v-col>
          <v-col cols="12" md="6">
            <contested-loss-list
              :key="`contested-zvp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Contested & Lost ZVP Candidates "
              :designation="4"
              :type="8"
            />
          </v-col>
        </v-row>

        <!-- Elected Lists -->
        <v-row v-if="ResultFlag">
          <v-col cols="12" md="6">
            <elected-list
              :key="`elected-zp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Elected ZP "
              :designation="3"
              :type="10"
            />
          </v-col>
          <v-col cols="12" md="6">
            <elected-list
              :key="`elected-zvp-${componentsRefreshKey}`"
              :year="JciYearCode"
              :zone="ZoneCode"
              title="Elected ZVP  "
              :designation="4"
              :type="11"
            />
          </v-col>
        </v-row>

        <!--Election Result-->
        <v-row v-if="ResultFlag">
          <v-col cols="12" md="6">
            <election-result-list
              :key="`election-zp-${componentsRefreshKey}`"
              :conference="this.conference.ConferenceId"
              :zone="ZoneCode"
              title="Election Results of ZP"
              :designation="3"
              :type="9"
            />
          </v-col>
          <v-col cols="12" md="6">
            <election-result-list
              :key="`election-zvp-${componentsRefreshKey}`"
              :conference="this.conference.ConferenceId"
              :zone="ZoneCode"
              title="Election Results of ZVP"
              :designation="4"
              :type="9"
            />
          </v-col>
        </v-row>

        <!-- LO Votes List -->
        <v-row v-if="ResultFlag">
          <v-col cols="12">
            <lo-votes-list
              :key="`lo-votes-${componentsRefreshKey}`"
              :zone="ZoneCode"
              title="LO Information"
              :type="12"
            />
          </v-col>
        </v-row>

        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

  <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import NominationList from "@/view/pages/erp/reports/conference/NominationList.vue";
import WithdrawalList from "@/view/pages/erp/reports/conference/WithdrawalList.vue";
import DisqualifiedList from "@/view/pages/erp/reports/conference/DisqualifiedCandidates.vue";
import contestedLossList from "@/view/pages/erp/reports/conference/ContestedLossList.vue";
import ElectionResultList from "@/view/pages/erp/reports/conference/ElectionResultList.vue";
import ElectedList from "@/view/pages/erp/reports/conference/ElectedList.vue";
import LoVotesList from "@/view/pages/erp/reports/conference/LoVotesList.vue";

export default {
  mixins: [common],
  components: {
    NominationList,
    WithdrawalList,
    DisqualifiedList,
    contestedLossList,
    ElectedList,
    ElectionResultList,
    LoVotesList,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      ProgressLoadingFlag: false,

      conference: null,
      ConferenceId: null,
      electionConducted: false,
      ResultFlag: false,
      // key used to force remount child components when zone/year changes
      componentsRefreshKey: 0,

      ExcelDownloadFlag: false,
      ExcelLoadingFlag: false,
      ExcelFileFlag: false,

      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      DownloadFlag: 0,
      ExcelFileName: "",
      excel_fields: {
        "LO Id": "LomId",
        "Zone Id": "ZoneId",
        "LO Name": "LomName",
        "President Name": "LomPresidentFullName",
        "LO NAME": "LomName",
        "Mobile No": "LomPresidentMobileNo",
        "Email Id": "LomPresidentEmailid",
      },

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},

      recordToEdit: "",
      record: {},
      editRecordPrompt: false,
      previewRecordPrompt: false,

      selectedData: {},

      zone: {},
      lom: {},

      JciYearCodeRules: [],
      JciYearCode: "",
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      yearCode: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      RoleId: "",
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      this.ProgressLoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;

        this.pageData();
      }
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.ProgressLoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    RegionCodeOptions: function () {
      console.log("watch RegionCodeOptions");
      this.RegionCodeOptionsLoading = false;
      this.ProgressLoadingFlag = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ProgressLoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    JciYearCode: function () {
      console.log("watch JciYearCode");
      this.getZoneCodeOptions();
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      // if results are visible and zone changed, refresh conference records and remount child lists
      if (this.ResultFlag) {
        this.getConferenceRecords();
        // increment key so child components remount
        this.componentsRefreshKey += 1;
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "conference_settings",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    // code 1
    validate() {
      if (this.$refs.form1.validate()) {
        this.snackbar = true;
      }
    },
    hideEditRecordPrompt() {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      this.searchForm();
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var LomId = tr.LomId;
        console.log("LomId=" + LomId);
        this.record = tr;
        this.recordToEdit = LomId;
        this.editPageDescription =
          "Assign 2021 LO President for " + tr.LomName;
        this.editRecordPrompt = true;
      } else {
        var message = "Kindly select one record to modifiy";
        this.toast("error", message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    pageData() {
      console.log("refreshPageData called");
      this.getJciYearCodeOptions();
      this.getRegionCodeOptions();
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      this.LoadingFlag = true;
      this.ProgressLoadingFlag = true;
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 8,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
      // hide global overlay when options loaded via watcher JciYearCodeOptions
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ProgressLoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/zone/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getConferenceRecords() {
      console.log("getConferenceRecords called");
      // show both small and global loaders
      this.LoadingFlag = true;
      this.ProgressLoadingFlag = true;
      this.SearchFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nomination-conference/show";
      var upload = {
        UserInterface: 2,
        Zone: this.ZoneCode,
      };

      const thisIns = this;
      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          var output = response.data.output;
          var flag = response.data.flag;
          var records = response.data.records;

          if (flag == 1) {
            thisIns.conference = records;
            thisIns.electionConducted =
              records.ZvpElectionConducted == 1 ? true : false;
            thisIns.ConferenceId = records.ConferenceId;
            thisIns.ResultFlag = true;
            // success - stop loaders and enable results
            thisIns.LoadingFlag = false;
            thisIns.ProgressLoadingFlag = false;
            thisIns.SearchFlag = false;
            thisIns.toast("success", output);
          } else {
            thisIns.ProgressLoadingFlag = false;
            thisIns.SearchFlag = false;
            thisIns.LoadingFlag = false;
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
          thisIns.ProgressLoadingFlag = false;
          thisIns.SearchFlag = false;
        });
    },
  },
  beforeMount() {
    var CurrentJciYearId = this.$session.get("CurrentJciYearId");
    // CurrentJciYearId = 11;
    CurrentJciYearId =
      CurrentJciYearId == (null || undefined) ? "" : CurrentJciYearId;
    console.log({ CurrentJciYearId });
    // this.JciYearCode = CurrentJciYearId;

    this.refreshPageData();
  },
};
</script>
  <style lang="scss">
#all-events-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
  .notes-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }
  .notes-content {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 15px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
  }
}
.overlay-card {
  min-width: 320px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff, #f3f5ff);
}

.report-card {
  border-radius: 12px;
  overflow: hidden;
}

.header-sheet {
  background: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
  color: #fff;
}

.report-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.report-subtitle {
  opacity: 0.95;
  font-size: 14px;
  margin-top: 6px;
  color: #fff;
}

.report-avatar {
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15),
    rgba(255, 255, 255, 0.05)
  );
}

.search-btn {
  transition: transform 160ms ease, box-shadow 160ms ease;
  background: linear-gradient(90deg, #8950fc 0%, #6a11cb 100%) !important;
  box-shadow: 0 6px 18px rgba(105, 72, 252, 0.18);
}

.search-btn:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 10px 30px rgba(105, 72, 252, 0.22);
}

.conference-info-card {
  border-left: 4px solid rgba(137, 80, 252, 0.9);
  transition: transform 220ms ease, box-shadow 220ms ease;
  background: linear-gradient(180deg, #ffffff, #fbfbff);
}

.conference-info-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 30px rgba(35, 56, 131, 0.06);
}

.detail-label {
  color: #333;
  min-width: 160px;
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 350ms cubic-bezier(0.2, 0.8, 0.2, 1);
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(12px);
}

.card-fade-enter-active,
.card-fade-leave-active {
  transition: all 300ms ease;
}
.card-fade-enter,
.card-fade-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.995);
}

/* subtle button focus */
.v-btn:focus {
  box-shadow: 0 6px 20px rgba(41, 98, 255, 0.12) !important;
}

/* small responsive tweaks */
@media (max-width: 960px) {
  .detail-label {
    min-width: 120px;
  }
  .report-avatar {
    display: none;
  }
}

#all-events-list {
  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }
  .notes-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }
  .notes-content {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.8em;
  }
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 15px;
  }
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
  }
}
</style>